<template>
    <div class="message-list dashboard-card">
        <CardTemplate border-class="message-section msglist-ipadding">
            <!-- HEADER -->
            <template v-slot:header>
                <section class="card-title">
                    <span class="me-2"> Unread Messages </span>
                    <span class="me-2"> ({{ myMessagesTotal }}) </span>
                    <a
                        tabindex="0"
                        href="javascript:void(0);"
                        role="button"
                        v-custom-popover="{
                            content: tooltip,
                            placement: 'left',
                            className: 'w-25 font-size-sm info-popup'
                        }"
                    >
                        <i class="fas fa-info-circle text-primary"></i>
                    </a>
                </section>
                <section class="ms-auto d-flex align-items-center cursor-pointer">
                    <div
                        v-show="myMessagesList.length"
                        v-tooltip="{ title: `Click to sort messages by date.` }"
                        @click="sortByScheduleDate()"
                        class="d-flex flex-column align-items-center"
                    >
                        <span class="icon small">
                            <i :class="isAscending ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up'"></i>
                            <i class="fas fa-calendar-alt"></i>
                        </span>
                        <span class="text font-size-sm fw-bold me-2 blue-text">Sort</span>
                    </div>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- DATA -->
            <template v-slot:content>
                <ScrollPagination
                    class="w-100 h-100"
                    :page-number="pageNumber"
                    :all-pages-loaded="allPagesLoaded"
                    :is-loading="isLoading"
                    :has-error="hasError"
                    v-on:pageNumberUpdate="pageNumberUpdated"
                >
                    <section
                        v-if="myMessagesTotal > 0"
                        class="d-flex flex-column flex-nowrap w-100 h-100 overflow-auto scroll-paginate"
                        :class="`${!isNewScroll ? '' : userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                    >
                        <div v-for="message in myMessagesList" :key="message.Id" class="router-message">
                            <div class="message-data">
                                <div class="d-flex">
                                    <span class="fw-bold">{{ message.FromName }}</span>
                                    <span class="ms-auto me-1 font-size-xs">{{
                                        formatDate(message.Sent, "MM/DD/YY")
                                    }}</span>
                                </div>
                                <a class="subject" href="javascript:void(0);" @click="viewMessage(message)">
                                    {{ message.Subject }}
                                </a>
                                <div class="d-flex flex-row align-items-center">
                                    <ProductPill
                                        class="application-name"
                                        :product-id="getApplicationId(message.Application)"
                                    />
                                    <span class="text-default ms-2 font-size-2xs">{{ message.AgencyName }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- LOADING -->
                        <div class="loading-state" v-if="!hasError && isLoading">
                            <i class="fas fa-spinner fa-pulse fa-fw"></i>
                            <b class="mx-2">Loading your Messages</b>
                            <i class="fas fa-spinner fa-pulse fa-fw"></i>
                        </div>
                        <!-- ERROR -->
                        <div class="error-state" v-if="hasError && !isLoading">
                            <p>There was a problem while fetching your messages.<br />Please try again.</p>
                            <button class="btn btn-primary" @click="getData()">Try Again</button>
                        </div>
                    </section>
                    <!-- NO DATA -->
                    <p class="no-data" v-if="myMessagesTotal == 0 && !isLoading && !hasError">
                        <i>You have no new messages.</i>
                    </p>
                </ScrollPagination>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./PersonalMessageList.ts"></script>
<style src="./PersonalMessageList.scss"></style>
